<template>
  <div>
    <z-stance :show-info="false" :descText="stanceInfo" v-show="showStance" @click="checkBizLicenseInfo" btn-text="点击重试"/>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Stance } from '@zz-common/zz-ui'
import { getbizlicensestatus } from '../../api/resourceApi'
import { queryParams } from '../../lib/utils'

const query = queryParams()

export default {
  name: 'QuaAuthIndex',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      authSource: query.authSource || this.$route.query.authSource,
      stanceInfo: '网络错误',
      showStance: false
    }
  },
  components: {
    zStance: Stance
  },
  methods: {
    toNextPage(status) {
      const skipPath = status == 1 ? '/qualityauth/checkinfo' : '/qualityauth/license'
      this.$router.replace({
        path: skipPath,
        query: {
          sourceCode: this.sourceCode,
          authSource: this.authSource
        }
      })
    },
    checkBizLicenseInfo() {
      getbizlicensestatus({ sourceCode: this.sourceCode, authSource: this.authSource })
        .then((res) => {
          console.log('getbizlicenseinfoRes', res)
          const { status } = res
          this.toNextPage(status)
        })
        .catch((err) => {
          console.error(err)
          this.stanceInfo = err
          this.showStance = true
        })
    }
  },
  created() {
    native.setTitle({
      title: '资质认证'
    })
    this.checkBizLicenseInfo()
  }
}

</script>
<style>
</style>